import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import service from "../baseHttpService";

class AllocationService {
  DoGetAllocationList(input: { isUseMainDatabase: boolean }) {
    const _input = {
      merchantId: MerchantId(),
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return service.peakExportAPI.post("/api/Allocation/GetAllocationList", _input, SetHeaderService());
  }
}

export default new AllocationService();
